<template>
	<div class="d21-wrapper-center">
		<div class="d21-profile">
			<div class="d21-profile__venue" v-if="Channel.Address">
				<img v-if="Channel.Theme && Channel.Theme.Images && Channel.Theme.Images.Logo" :src="Channel.Theme.Images.Logo" :style="logoWidth" />
				<div>
					<span class="venue">{{ Channel.Address.Venue.Name }}</span>
					<span>{{ Channel.Address.Venue.AddressLine1 }}</span>
					<span>{{ Channel.Address.Venue.PostalCode }} {{ Channel.Address.Venue.City }}</span>
				</div>
			</div>
			<div class="d21-profile__back" @click="$router.back()" v-if="$route.params.section !== 'login' && $route.params.section !== 'home'"><i class="material-icons">arrow_back</i>{{ T("back") }}</div>
			<Login v-if="$route.params.section === 'login'" @onProfileLoaded="onProfileLoaded" @profileRegister="onProfileRegister" />
			<Home v-else-if="$route.params.section === 'home'" />
			<Settings v-else-if="$route.params.section === 'settings' || $route.params.section === 'register'" />
			<Reservations v-else-if="$route.params.section === 'reservations'" />
		</div>
	</div>
</template>

<script>
	import Login from "./components/profile-login.vue";
	import Home from "./components/profile-home.vue";
	import Settings from "./components/profile-settings.vue";
	import Reservations from "./components/profile-reservations.vue";
	import baseMixin from "./mixins/base";

	export default {
		mixins: [baseMixin],
		name: "d21-app-profile",
		components: {
			Login,
			Home,
			Settings,
			Reservations
		},
		computed: {
			logoWidth() {
				return this.Channel.Theme.Widths && this.Channel.Theme.Widths.Logo ? `width: ${this.Channel.Theme.Widths.Logo}` : "width: 200px";
			}
		},
		mounted() {
			//
			this.checkForCookieLogin(
				() => {
					if (this.$route.path.includes("profile/home")) return;
					this.$router.push(`/${this.$route.params.channel}/profile/home`);
				},
				() => {
					if (this.$route.params.section !== 'login' && this.$route.params.section !== 'register' && (!this.profile || !this.profile.Contact.GivenName)) {
						this.$router.push(`/${this.$route.params.channel}/profile/login`);
					}
				}
			);
		},
		methods: {
			onProfileLoaded() {
				this.$router.push(`/${this.$route.params.channel}/profile/home`);
			},
			onProfileRegister() {
				this.$router.push(`/${this.$route.params.channel}/profile/register`);
			},
		},
	};
</script>